import {HttpClient} from "../../service/httpClient/HttpClient";
import {FileManagerTypes} from "../../component/fileManager/FileManager";
import {uploadFile} from "../../service/uploaderService/UploaderService";

export class ChartsService {

    constructor() {
        this.httpClient = new HttpClient()
    }


    getCharts(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `site-charts`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    createNewChart(title, description, file) {
        return new Promise((resolve, reject) => {
            this.uploadImageFile(file)
                .then(response => {
                    this.httpClient.post(
                        `site-charts`,
                        {
                            title: title,
                            description: description,
                            enabled: true,
                            chartPhotoId: response.id
                        }
                    ).then(resolve).catch(reject)
                }).catch(reject)
        })
    }


    uploadImageFile(imageFile, handleHideLoading, setUploadPercent) {
        return new Promise((resolve, reject) => {
            uploadFile(
                imageFile,
                FileManagerTypes.CHART_IMAGES.uploadUrl,
                setUploadPercent,
                () => {
                },
                handleHideLoading,
            ).then(resolve).catch(reject)
        })
    }

    getChartDetail(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `site-charts/${id}`
            ).then(resolve).catch(reject)
        })
    }

    updateChartInfo(id, name, description, photoId, file, enabled) {
        return new Promise((resolve, reject) => {
            if (file) {
                this.uploadImageFile(
                    file
                ).then(response => {
                    this.handleUpdateChart(id, name, description, response.id, enabled)
                        .then(resolve).catch(reject)
                }).catch(reject)
            } else
                this.handleUpdateChart(id, name, description, photoId, enabled)
                    .then(resolve).catch(reject)
        })
    }

    handleUpdateChart(id, title, description, photoId, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `site-charts/${id}`,
                {
                    title: title,
                    description: description,
                    enabled: enabled,
                    chartPhotoId: photoId
                }
            ).then(resolve).catch(reject)
        })
    }
}
